import { trpc } from '@/shared/api/trpc';

export const useRemoveTaskCollection = () => {
  const utils = trpc.useUtils();
  return trpc.taskCollections.remove.useMutation({
    onSettled: () => {
      // Removing a collection cascades to tasks (DB FK), so invalidate
      // tasks queries too. Also clear the per-itinerary availability
      // cache since the deleted collection vanishes from it.
      utils.taskCollections.list.invalidate();
      utils.taskCollections.availableForItinerary.invalidate();
      utils.tasks.list.invalidate();
      utils.tasks.flaggedCount.invalidate();
      utils.tasks.getNextActions.invalidate();
    },
  });
};
